// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","hero":"Home_hero__tSEiQ","about":"Home_about__28DcV"};